export const EMPLOYEE_UPLOAD_REQUEST = 'EMPLOYEE_UPLOAD_REQUEST';
export const EMPLOYEE_UPLOAD_SUCCESS = 'EMPLOYEE_UPLOAD_SUCCESS';
export const EMPLOYEE_UPLOAD_FAIL = 'EMPLOYEE_UPLOAD_FAIL';
export const EMPLOYEE_UPLOAD_RESET = 'EMPLOYEE_UPLOAD_RESET';

export const EMPLOYEE_LIST_REQUEST = 'EMPLOYEE_LIST_REQUEST';
export const EMPLOYEE_LIST_SUCCESS = 'EMPLOYEE_LIST_SUCCESS';
export const EMPLOYEE_LIST_FAIL = 'EMPLOYEE_LIST_FAIL';

export const EMPLOYEE_CREATE_REQUEST = 'EMPLOYEE_CREATE_REQUEST';
export const EMPLOYEE_CREATE_SUCCESS = 'EMPLOYEE_CREATE_SUCCESS';
export const EMPLOYEE_CREATE_FAIL = 'EMPLOYEE_CREATE_FAIL';
export const EMPLOYEE_CREATE_RESET = 'EMPLOYEE_CREATE_RESET';

export const EMPLOYEE_UPDATE_REQUEST = 'EMPLOYEE_UPDATE_REQUEST';
export const EMPLOYEE_UPDATE_SUCCESS = 'EMPLOYEE_UPDATE_SUCCESS';
export const EMPLOYEE_UPDATE_FAIL = 'EMPLOYEE_UPDATE_FAIL';
export const EMPLOYEE_UPDATE_RESET = 'EMPLOYEE_UPDATE_RESET';

export const EMPLOYEE_DELETE_REQUEST = 'EMPLOYEE_DELETE_REQUEST';
export const EMPLOYEE_DELETE_SUCCESS = 'EMPLOYEE_DELETE_SUCCESS';
export const EMPLOYEE_DELETE_FAIL = 'EMPLOYEE_DELETE_FAIL';
export const EMPLOYEE_DELETE_RESET = 'EMPLOYEE_DELETE_RESET';

export const EMPLOYEE_MARK_LEFT_REQUEST = 'EMPLOYEE_MARK_LEFT_REQUEST';
export const EMPLOYEE_MARK_LEFT_SUCCESS = 'EMPLOYEE_MARK_LEFT_SUCCESS';
export const EMPLOYEE_MARK_LEFT_FAIL = 'EMPLOYEE_MARK_LEFT_FAIL';
export const EMPLOYEE_MARK_LEFT_RESET = 'EMPLOYEE_MARK_LEFT_RESET';

export const EMPLOYEE_REJOIN_REQUEST = 'EMPLOYEE_REJOIN_REQUEST';
export const EMPLOYEE_REJOIN_SUCCESS = 'EMPLOYEE_REJOIN_SUCCESS';
export const EMPLOYEE_REJOIN_FAIL = 'EMPLOYEE_REJOIN_FAIL';
export const EMPLOYEE_REJOIN_RESET = 'EMPLOYEE_REJOIN_RESET';
